<template>
  <button :type="type" class="fomo-button" :class="rootClass">
    <template v-if="plain">
      <i v-if="resolvedIcon" :class="resolvedIcon" aria-hidden="true"></i><span><slot /></span>
    </template>
    <template v-else>
    <span :class="prefix + '-glow'" aria-hidden="true"></span>
    <span v-if="variant === 'action'" :class="prefix + '-clip'" aria-hidden="true"><span :class="prefix + '-ring'"></span></span>
    <span v-else :class="prefix + '-ring'" aria-hidden="true"></span>
    <span v-if="variant === 'action'" :class="prefix + '-plate'" aria-hidden="true"></span>
    <span :class="prefix + '-inner'">
      <span :class="prefix + '-copy'"><slot /></span>
      <span v-if="resolvedIcon" :class="prefix + '-icon'" aria-hidden="true"><i :class="resolvedIcon"></i></span>
    </span>
    </template>
  </button>
</template>
<script>
export default {
  name: 'FomoButton',
  props: {
    variant: { type: String, default: 'secondary', validator: v => ['primary', 'secondary', 'action', 'quiet', 'text'].includes(v) },
    type: { type: String, default: 'button' },
    icon: { type: String, default: null },
  },
  computed: {
    plain() { return ['quiet', 'text'].includes(this.variant) },
    resolvedIcon() { return this.icon === null ? (this.plain ? '' : 'fas fa-arrow-right') : this.icon },
    prefix() { return this.variant === 'action' ? 'event-view__action' : 'fomo-hero__action' },
    rootClass() { return this.plain ? ['fomo-button--plain', `fomo-button--${this.variant}`] : [this.prefix, this.prefix + '--' + (this.variant === 'action' ? 'primary' : this.variant)] },
  },
}
</script>
